module.exports = __webpack_public_path__ + "img/users-icon.80ad9d08.svg";